/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const navItems = {
  customers: "Customers",
  employees: "Employees",
  services: "Service Request Catalog",
  serviceCommitments: "Service Commitments",
  productCatalog: "Products",
  requestCatalog: "Request Catalog",
  tool: "Tooling",
  reporting: "Reporting",
};
